<template>
  <div class="app-container">
    <!-- 标题 -->
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <!-- 数据筛选 -->
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="关键字" prop="keyWords">
        <el-input v-model="queryParams.keyWords" placeholder="请输入模块名或描述" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="业务类别" prop="businessType">
          <el-select v-model="queryParams.businessType" placeholder="业务类别" clearable>
            <el-option v-for="dict in dict.type.business_type" :key="dict.value" :label="dict.label" :value="dict.value"/>
          </el-select>
      </el-form-item>
      <el-form-item label="请求方式" prop="requestMethod">
        <el-select v-model="queryParams.requestMethod" placeholder="请求方式" clearable>
          <el-option v-for="dict in dict.type.request_method" :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="操作IP" prop="ip">
          <el-input v-model="queryParams.ip" placeholder="请输入登录地址" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="操作人" prop="nickname">
          <el-input v-model="queryParams.nickname" placeholder="请输入用户名称" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="状态" prop="status">
          <el-select v-model="queryParams.status" placeholder="操作状态" clearable>
              <el-option v-for="dict in dict.type.sys_log_status" :key="dict.value" :label="dict.label" :value="dict.value"/>
          </el-select>
      </el-form-item>
      <el-form-item label="操作时间" >
          <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="-"
                          start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['monitor:operlog:remove']" type="danger" size="mini" icon="el-icon-deleteItem" :disabled="multiple" @click="handleDeleteLog">批量删除</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>
    <!-- 权限列表 -->
    <el-table ref="tables" @selection-change="handleSelectionChange" v-loading="loading" :data="logList" :row-class-name="tableRowClassName" :default-sort="defaultSort" @sort-change="handleSortChange" >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column prop="optModule" label="系统模块" align="center" min-width="120" :show-overflow-tooltip="true"/>
      <el-table-column prop="businessType" label="业务类型" align="center" width="90px">
          <template slot-scope="scope">
              <dict-tag :options="dict.type.business_type" :value="scope.row.businessType"/>
          </template>
      </el-table-column>
      <el-table-column prop="optDesc" label="操作描述" align="center" min-width="180" :show-overflow-tooltip="true"/>
      <el-table-column prop="requestMethod" label="请求方式" align="center" width="100">
        <template slot-scope="scope" v-if="scope.row.requestMethod">
          <dict-tag :options="dict.type.request_method" :value="scope.row.requestMethod"/>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="操作人员" align="center" />
      <el-table-column prop="ipAddr" label="操作ip" align="center" width="130" />
      <el-table-column prop="ipSource" label="操作地址" align="center" min-width="100" :show-overflow-tooltip="true"/>
      <el-table-column label="操作状态" align="center" prop="status" width="90px">
        <template slot-scope="scope">
          <dict-tag :options="dict.type.sys_log_status" :value="scope.row.status"/>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="操作日期" align="center" width="180" >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.createTime | dateTime }} </span>
        </template>
      </el-table-column>
      <el-table-column label="消耗时间" align="center" prop="costTime" width="100" :show-overflow-tooltip="true" sortable="custom" :sort-orders="['descending', 'ascending']">
        <template slot-scope="scope">
          <span>{{ scope.row.costTime }}毫秒</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button v-hasPermi="['monitor:operlog:query']" size="mini" type="text" icon="el-icon-view" @click="handleDetail(scope.row)">查看</el-button>
          <el-button v-hasPermi="['monitor:operlog:remove']" size="mini" type="text" icon="el-icon-delete" @click="handleDeleteLog(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
    <!-- 查看详情 -->
    <operlog-detail :visible.sync="detailVisible" :row="detailRow" />
  </div>
</template>

<script>
import OperlogDetail from './detail'
import { logList, delLogs } from "@/api/log/log";

export default {
  created() {
    this.getList();
  },
  components: { OperlogDetail },
  dicts: ['sys_log_status','business_type','request_method'],
  data() {
    return {
      loading: true,
      showSearch:true,
      logList: [],
      //非多个禁用
      multiple: true,
      logIds: [],
      total: 0,
      // 是否现实详情弹窗
      detailVisible: false,
      detailRow:{},
      isDelete: false,
      optLog: {},
      dateRange:[],
      // 默认排序
      defaultSort: {prop: "createTime", order: "descending"},
      queryParams:{
        current: 1,
        size: 10,
        keyWords: null,
        ip: null,
        nickname: null,
        status: null,
        businessType: null,
        requestMethod: null,
        startTime:null,
        endTime:null,
      }
    };
  },
  methods: {
    handleSelectionChange(selection) {
      this.logIds = selection.map(item => item.logId);
      this.multiple = !selection.length;
    },
    /** 排序触发事件 */
    handleSortChange(column, prop, order) {
      this.queryParams.orderByColumn = column.prop;
      this.queryParams.isAsc = column.order;
      this.getList();
    },
    handleQuery(){
      this.queryParams.current = 1;
      this.getList();
    },
    resetQuery(){
      this.dateRange = [];
      this.queryParams.startTime=undefined;
      this.queryParams.endTime=undefined;
      this.resetForm("queryForm");
      this.queryParams.current = 1;
      this.$refs.tables.sort(this.defaultSort.prop, this.defaultSort.order)
    },
    getList() {
      this.loading = true;
      if( Array.isArray(this.dateRange) && this.dateRange.length>0){
        this.queryParams.startTime=this.dateRange[0];
        this.queryParams.endTime=this.dateRange[1];
      }
      logList(this.queryParams).then(res => {
        this.logList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    },
    handleDeleteLog(row) {
      let ids = this.logIds;
      if (row.logId) {
        ids = [row.logId];
      }
      this.$modal.confirm('是否确认删除日志ID为"' + ids + '"的数据项？').then(function() {
          return delLogs({ ids: ids });
        }).then(() => {
          this.getList();
          this.$modal.msgSuccess("删除成功");
        }).catch(() => {});
    },
    handleDetail(row) {
      this.detailRow = row
      this.detailVisible = true;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "success-row";
      } else {
        return "";
      }
    }
  },
  computed: {
    tagType() {
      return function(type) {
        switch (type) {
          case "GET":
            return "";
          case "POST":
            return "success";
          case "PUT":
            return "warning";
          case "DELETE":
            return "danger";
        }
      };
    }
  }
};
</script>
